import React from 'react';
import { NextPageWithLayout } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import extractFromContext from '@helpers/utils/extract-from-context';
import DefaultLayout from '@layouts/default-layout';
import ConsignmentForm from '@components/consignment-form/consignment-form';
import { getAppInitialProps } from '@helpers/initial-props';
import { useTranslation } from 'next-i18next';

const ConsignmentPage: NextPageWithLayout = (): React.JSX.Element => {
  const { t } = useTranslation('default-layout');
  return (
    <>
      <Head>
        <title>{t('SEO.LOGO_ALT')}</title>
        <meta
          property="og:title"
          content={t('SEO.LOGO_ALT')}
          key="og:title"
        />
      </Head>
      <ConsignmentForm></ConsignmentForm>
    </>
  );
};

ConsignmentPage.Layout = [DefaultLayout];
ConsignmentPage.PageType = 'ConsignmentPage';

export async function getServerSideProps(context) {
  const { locale } = extractFromContext(context);
  const initialProps = await getAppInitialProps(context);

  const translations = await serverSideTranslations(locale, ['default-layout', 'vc-authentication', 'a11y', 'common']);
  return {
    props: {
      ...initialProps,
      ...translations,
    },
  };
}

export default ConsignmentPage;
